import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdditionalCompanyData, NotesModel, NOTE_TYPES } from 'src/app/domains/companies/models';
import { CompanyService } from 'src/app/domains/companies/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-edit-notes-popup',
  templateUrl: './edit-notes-popup.component.html',
  styleUrls: ['./edit-notes-popup.component.scss']
})
export class EditNotesPopupComponent implements OnInit {
  @Input() companyId: number;
  @Input() additionalCompanyData: AdditionalCompanyData;
  @Input() action: string;
  @Input() noteType: NOTE_TYPES;
  public notesForm: UntypedFormGroup;
  public loading: boolean = false;
  @Output() emitValue: EventEmitter<string> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private companyService: CompanyService,
    private notification: NotificationService
    ) { }

  ngOnInit(): void {
    let noteType = `notes_${this.noteType}`;
    this.notesForm = this.fb.group({
      notesValue: new UntypedFormControl(this.additionalCompanyData[noteType])
    });
  }

  onUpdateNotes(): void {
    let value = this.notesForm.value;
    let payload: NotesModel = {
      notes_administration: this.noteType === NOTE_TYPES.administration ? value.notesValue : this.additionalCompanyData.notes_administration,
      notes_sales: this.noteType === NOTE_TYPES.sales ? value.notesValue : this.additionalCompanyData.notes_sales,
      notes_success: this.noteType === NOTE_TYPES.success ? value.notesValue : this.additionalCompanyData.notes_success,
      notes_support: this.noteType === NOTE_TYPES.support ? value.notesValue : this.additionalCompanyData.notes_support,
    };
    this.loading = true;
    this.companyService.updateCompanyNotes(this.companyId, payload).subscribe(res => {
      this.loading = false;
      this.emitValue.emit('company.overview.notes.modal.success');
      this.close();
    }, () => {
      this.loading = false;
    });
  }

  close() {
    this.activeModal.close();
  }
}
